import { React } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { ContextSearchProvider } from './pages/Dashboard/ContextSearch';
import { AppRoutes } from './routes/AppRoutes';

export function App() {
  return (
    <ContextSearchProvider>
      <AppRoutes />
      <ToastContainer
        position="bottom-right"
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </ContextSearchProvider>
  );
}
